<template>
  <!-- 商品命名规则弹窗 -->
  <el-dialog
    :title="titleDialog"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    @close="onHandleClose"
    width="600px"
    class="dialog"
    center
  >
    <div class="contents">
      <el-form
        label-width="170px"
        ref="refForm"
        :model="formData"
        :rules="formRules"
      >
        <el-form-item label="商品命名规则" prop="name">
          <div class="d-flex a-center">
            <el-input
              v-model="formData.name"
              :disabled="true"
              placeholder="请输入"
              clearable
              maxlength="10"
            ></el-input>
            <div class="ml10">
              <el-button
                type="primary"
                :disabled="!formData.name"
                @click="resetHandle"
                >重置</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="选择属性" prop="field">
          <div class="d-flex">
            <el-select
              v-model="formData.field"
              filterable
              placeholder="请选择属性"
              :loading="loadingData"
            >
              <el-option
                v-for="item in dataList"
                :key="item.id"
                :label="item.field_key"
                :value="item.field_key"
                :disabled="item.is_show != 1"
              >
              </el-option>
            </el-select>

            <div class="ml10">
              <el-button
                type="primary"
                :disabled="!formData.field"
                @click="addHandle('custom')"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="公共属性" prop="field1">
          <div class="d-flex">
            <el-select
              v-model="formData.field1"
              filterable
              placeholder="请选择公共属性"
            >
              <el-option
                v-for="item in publicArr"
                :key="item.key"
                :label="item.name"
                :value="item.key"
              >
              </el-option>
            </el-select>

            <div class="ml10">
              <el-button
                type="primary"
                :disabled="!formData.field1"
                @click="addHandle('public')"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>
        <el-form-item label="符号" prop="prefix">
          <div class="d-flex">
            <el-select
              v-model="formData.prefix"
              filterable
              placeholder="请选择符号"
            >
              <el-option
                v-for="item in PUBLIC_PROPERTY_ENUM"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>

            <div class="ml10">
              <el-button
                type="primary"
                :disabled="!formData.name || !formData.prefix"
                @click="addFuHao"
                >添加</el-button
              >
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="onHandleClose">取消</el-button>
      <el-button type="primary" @click="onHandleSubmit" :loading="loadingSubmit"
        >保存</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import cloneDeep from "lodash/cloneDeep";
import {
  postCategoriesCustomFieldList,
  postCategoriesProductNameRuleSave,
  getCategoriesNameRulePublicField,
} from "@/api/generalControl/key-attributes.js";
import { PUBLIC_PROPERTY_ENUM } from "../../utils/enum/index";

export default {
  name: "product-name-rule",
  props: {},
  data() {
    return {
      PUBLIC_PROPERTY_ENUM,
      dialogVisible: false,
      loadingSubmit: false,
      loadingData: false, // 选择属性loading
      titleDialog: "商品命名规则",
      formData: {
        cid: "", // 品类ID,
        name: "",
        prefix: "",
        field: "",
        field1: "",
      }, // 表单数据
      formDataClone: {}, // 复制一份，用于初始化
      formRules: {
        // name: [
        //   {
        //     required: true,
        //     trigger: ["blur", "change"],
        //     message: "请选择属性",
        //   },
        // ],
        // is_join_custom: [
        //   {
        //     required: true,
        //     trigger: ["blur", "change"],
        //     message: "请选择是否自定义拼接名称",
        //   },
        // ],
      },
      configList: [
        { value: "1", label: "是" },
        { value: "0", label: "否" },
      ],
      dataList: [], // 选择属性下拉框数据
      fieldArr: [],
      publicArr: [], // 公共属性下拉
      cid: "",
    };
  },
  created() {},
  methods: {
    // 选择属性
    async postAjaxCategoriesCustomFieldList(id) {
      this.loadingData = true;
      try {
        const res = await postCategoriesCustomFieldList({
          cid: id,
        });
        this.dataList = res.data;
      } catch (error) {
        console.log(error, "postCategoriesCustomFieldList");
      } finally {
        this.loadingData = false;
      }
    },
    // 添加属性拼接
    addHandle(e) {
      if (e == "custom") {
        this.fieldArr.push({
          field_name: this.formData.field,
          field_key: this.formData.field,
          type: "custom",
          prefix: 0,
        });
        this.formData.field = "";
      } else {
        let tmpName = this.publicArr.filter(
          (item) => item.key == this.formData.field1
        );
        this.fieldArr.push({
          field_name: tmpName[0].name,
          field_key: this.formData.field1,
          type: "public",
          prefix: 0,
        });
        this.formData.field1 = "";
      }
      this.getShowName();
      console.log(this.fieldArr, "this.fieldArr===");
    },
    // 获取拼接名字
    getShowName() {
      let showName = [];
      this.fieldArr?.map((fItem) => {
        if (fItem.prefix) {
          let tmpFuHao = this.PUBLIC_PROPERTY_ENUM.filter(
            (item) => item.value == fItem.prefix
          );
          console.log(tmpFuHao, "tmpFuHao==");
          showName.push(
            tmpFuHao.length > 0
              ? `${tmpFuHao[0].left}${fItem.field_name}${tmpFuHao[0].right}`
              : `${fItem.field_name}`
          );
        } else {
          showName.push(fItem.field_name);
        }
      });
      console.log(showName, "showName==");
      this.formData.name = showName.join("");
      this.formData.prefix = ""; // 清空符号
    },
    // 添加符号
    addFuHao() {
      // 最后一个 增加符号
      this.fieldArr[this.fieldArr.length - 1].prefix = this.formData.prefix
        ? this.formData.prefix
        : 0;
      this.getShowName();
    },
    // 重置所有属性
    resetHandle() {
      this.formData.name = "";
      this.fieldArr = [];
      this.formData.field = "";
      this.formData.field1 = "";
      this.formData.prefix = "";
    },
    /**
     * 初始化
     */
    async onInitData(data, id) {
      console.log(data, id, "33");
      this.dialogVisible = true;
      this.cid = id;
      this.postAjaxCategoriesCustomFieldList(id);
      this.getAjaxCategoriesNameRulePublicField();
      this.formDataClone = cloneDeep(this.formData);
      if (data && data.length > 0) {
        this.fieldArr = JSON.parse(JSON.stringify(data));
        this.getShowName();
      } else {
        this.resetHandle();
      }
    },
    /**
     * 关闭操作
     */
    onHandleClose() {
      this.formData = {
        ...this.formDataClone,
      };
      this.fieldArr = [];
      this.dialogVisible = false;
    },
    /**
     * 确认
     */
    onHandleSubmit() {
      this.postAjaxCategoriesProductNameRuleSave();
    },
    /**
     * 提交
     */
    async postAjaxCategoriesProductNameRuleSave() {
      this.loadingSubmit = true;
      const params = {
        cid: this.cid,
        name_rule: this.fieldArr,
      };
      try {
        await postCategoriesProductNameRuleSave(params);
        this.$message.success("操作成功");
        this.$emit("on-change");
        this.onHandleClose();
      } catch (err) {
        console.log("ajax postCategoriesProductNameRuleSave err", err);
      } finally {
        this.loadingSubmit = false;
      }
    },
    // 获取公共属性下拉
    async getAjaxCategoriesNameRulePublicField() {
      try {
        const res = await getCategoriesNameRulePublicField();
        this.publicArr = res.data || [];
      } catch (error) {
        console.log(error, "getCategoriesNameRulePublicField==");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #13ae67;

.dialog {
  .contents {
    padding-top: 30px;
    padding-bottom: 20px;
    padding-right: 20px;
  }
}
</style>
